import { PatientExternalIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { FormContextValues } from '@dreryk/react-common';

import { guardianTranslationKeys } from '../../../../../translations';
import { MedicalLeaveFormSection } from '../../../common/formSections/MedicalLeaveFormSection';
import { GuardianBirthDateField } from '../../../common/formSections/personalData/GuardianBirthDateField';
import { MedicalLeaveFormInsurer } from '../../../common/MedicalLeaveFormInsurer';
import { GuardianMedicalLeaveFormBean, GuardianMedicalLeaveFormGuardian } from '../../guardianMedicalLeave.types';
import { GuardianSelect } from '../GuardianSelect/GuardianSelect';

import { RelationCodeSelect } from './RelationCodeSelect/RelationCodeSelect';

type GuardianDataSectionProps = {
   readonly controller: FormContextValues<GuardianMedicalLeaveFormBean>;
   readonly patientId: number;
   readonly patientExternalIdentifier: PatientExternalIdentifier;
   readonly initialGuardian?: GuardianMedicalLeaveFormGuardian;
   readonly shouldUseDefaultGuardianAddress: boolean;
};

export const GuardianDataSection = (props: GuardianDataSectionProps): JSX.Element => {
   const { guardian } = props.controller.watch(['guardian']);

   return (
      <MedicalLeaveFormSection title={guardianTranslationKeys.guardianData}>
         <GuardianSelect
            controller={props.controller}
            patientId={props.patientId}
            patientExternalIdentifier={props.patientExternalIdentifier}
            initialGuardian={props.initialGuardian}
            shouldUseDefaultGuardianAddress={props.shouldUseDefaultGuardianAddress}
         />
         {guardian?.guardianExternalIdentifier.accept<JSX.Element | null>({
            visitPesel: () => null,

            visitPassport: () => <GuardianBirthDateField register={props.controller.register} />,
            visitNationalIdentificationNumber: () => null,
         })}
         <MedicalLeaveFormInsurer controller={props.controller} label={guardianTranslationKeys.guardianInsuredIn} />
         <RelationCodeSelect controller={props.controller} />
      </MedicalLeaveFormSection>
   );
};
